import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import theme  from "theme.js";
import Box from "react-styled-box";
import S from "StyledBetSlipCheck.js";
import ModalOpacity from 'ModalOpacity.js';
import BetSlipDetails from 'BetSlipDetails.js';
import { translation } from "helpers/utilsHelper.js";
import { getBetSlipCheckResults, clearBetSlipCheckResults, toggleBetSlipDetailsModal } from 'betSlipCheckActions.js';
import Loader from 'Loader.js';
import _isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

const BetSlipCheck = ({
    getBetSlipCheckResults,
    clearBetSlipCheckResults,
    toggleBetSlipDetailsModal,
    events,
    error,
    isPending,
    isBetSlipDetailsOpen,
}) => {

    useEffect(() => {
        if (!_isEmpty(events)) {
            toggleBetSlipDetailsModal(true);
        }
    }, [events]);

    const [visible, setVisible] = useState(true);
    const [betSlipId, setBetSlipId] = useState('');

    const toggleVisibility = (event) => {
        setVisible(!visible);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        getBetSlipCheckResults(betSlipId);
    };

    const handleBetSlipCheckInputChange = (event) => {
        const adjustedBetSlipId = event.target.value.replace(/\D/, '');
        setBetSlipId(adjustedBetSlipId);
    };

    return (
        <S.BetSlipCheck>
            { isPending ?
                <Loader
                    color={theme.$loaderColor}
                />
                : (
                    <>
                        <S.BetSlipCheckHeader
                            as={Box}
                            justifyContent="flex-start"
                            alignItems="center"
                            onClick={toggleVisibility}
                        >
                            <S.BetSlipCheckHeaderTitle>
                                {translation("betSlipCheck_title")}
                            </S.BetSlipCheckHeaderTitle>
                            <S.ArrowIcon className={classNames({'ion':true, 'ion-ios-arrow-up': visible, 'ion-ios-arrow-down': !visible})}></S.ArrowIcon>
                        </S.BetSlipCheckHeader>
                        <S.BetSlipCheckBody
                            className="betSlipCheck__body"
                            visible={visible}
                        >
                            <S.BetSlipCheckContent>
                                <S.FormGroupWrapper
                                    as={Box}
                                    alignItems="center"
                                    flexDirection="column"
                                >
                                    <S.Label>{translation("betSlipCheck_label")}</S.Label>

                                    <S.Input
                                        autocomplete="off"
                                        autocorrect="off"
                                        placeholder={translation("betSlipCheck_placeholder")}
                                        autocapitalize="off"
                                        spellcheck="false"
                                        value={betSlipId}
                                        onChange={handleBetSlipCheckInputChange}
                                    />
                                </S.FormGroupWrapper>
                            </S.BetSlipCheckContent>
                            <S.BetSlipCheckFooter
                                as={Box}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <S.Button onClick={handleSubmit}>{translation("betSlipCheck_submit")}</S.Button>
                                {error && <S.Error>{error}</S.Error>}
                            </S.BetSlipCheckFooter>
                        </S.BetSlipCheckBody>
                    </>
                )}

            <ModalOpacity
                isOpen={isBetSlipDetailsOpen}
                toggleOpen={toggleBetSlipDetailsModal.bind(null, false)}
                title="BetSlip Details"
                showHeaderIcon={false}
                showCloseIcon={true}
                padding={0}
                width={'90%'}
            >
                <BetSlipDetails transactionId={betSlipId}/>
            </ModalOpacity>

        </S.BetSlipCheck>
    );
}

const mapStateToProps = ({ BetSlipCheck: { isPending, events, error, isBetSlipDetailsOpen } }) => {
    return {
        isPending,
        events,
        error,
        isBetSlipDetailsOpen,
    };
};

const mapDispatchToProps = {
    getBetSlipCheckResults,
    clearBetSlipCheckResults,
    toggleBetSlipDetailsModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BetSlipCheck);
